module.exports = "<span class=\"completer-list-item-holder\" [ngClass]=\"{'completer-title': type === 'title', 'completer-description': type === 'description'}\">\r\n  <span class=\"completer-list-item\" *ngFor=\"let part of parts\" [ngClass]=\"part.isMatch ? matchClass : null\">{{part.text}}</span>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Completer/components/completer-list-item-cmp.html
// module id = ./src/app/components/Completer/components/completer-list-item-cmp.html
// module chunks = main